/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UsuarioObtenerPorNombreCompletoGet$Params {
  Accept?: string;
  fullName?: string;
}

export function usuarioObtenerPorNombreCompletoGet(http: HttpClient, rootUrl: string, params?: UsuarioObtenerPorNombreCompletoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, usuarioObtenerPorNombreCompletoGet.PATH, 'get');
  if (params) {
    rb.header('Accept', params.Accept, {});
    rb.query('fullName', params.fullName, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

usuarioObtenerPorNombreCompletoGet.PATH = '/usuario/obtener-por-nombre-completo';
